export const ds_MicrositeHomepage_Partial = `
    fragment ds_MicrositeHomepage_Partial on ds_MicrositeHomepage_Entry {
        id
        canonicalUid
        uri
        title

        children {
            id
            uri
            title
            ...on ds_RedirectPage_Entry {
                redirectLink {
                    target
                }
            }
            children {
                id
                uri
                title
                ...on ds_RedirectPage_Entry {
                    redirectLink {
                        target
                    }
                }
            }
        }

        colorTheme
        logos_StickyNavLogoSize
        logos_StickyNavLogo {
            url
        }
        logos_HeaderLogoSize
        logos_HeaderLogo {
            url
        }
        logos_FooterLogoSize
        logos_FooterLogo {
            url
        }
        socials_SocialLinks {
            ... on socials_SocialLinks_Url_LinkType {
                title
                text
                target
                ariaLabel
                url
                icon {
                    type
                    set
                    name
                }
            }
        }
        mainNav_LogoPosition
        mainNav_PageLinksPosition
        mainNav_ColorTheme
        mainNav_ColorPalette
        mainNav_ApplyHeadingFontMenuItems
        mainNav_ShowBackground
        mainNav_Quicklinks {
            ... on ds_MainNavQuicklinksItem_Entry {
                mainNavQuicklinksItem_Heading
                mainNavQuicklinksItem_Links {
                    url
                    text
                    target
                    ariaLabel
                    ... on mainNavQuicklinksItem_Links_Custom_LinkType {
                        icon {
                            name
                            set
                            type
                        }
                    }
                    ... on mainNavQuicklinksItem_Links_Entry_LinkType {
                        icon {
                            name
                            set
                            type
                        }
                    }
                    ... on mainNavQuicklinksItem_Links_Url_LinkType {
                        icon {
                            name
                            set
                            type
                        }
                    }
                    ... on mainNavQuicklinksItem_Links_Phone_LinkType {
                        icon {
                            name
                            set
                            type
                        }
                    }
                    ... on mainNavQuicklinksItem_Links_Email_LinkType {
                        icon {
                            name
                            set
                            type
                        }
                    }
                }
            }
        }
        mainNav_Buttons {
            text
            url
            target
            ariaLabel
            isEmpty
            ... on mainNav_Buttons_Entry_LinkType {
                buttonStyle
            }
            ... on mainNav_Buttons_Custom_LinkType {
                buttonStyle
            }
            ... on mainNav_Buttons_Email_LinkType {
                buttonStyle
            }
            ... on mainNav_Buttons_Phone_LinkType {
                buttonStyle
            }
            ... on mainNav_Buttons_Url_LinkType {
                buttonStyle
            }
        }
        mainNav_Watermark {
            id
            url
        }
    }
`